import React, { useState } from "react";
import "./buyMinutesModal.css";

const BuyMinutesModal = ({ isOpen, onClose, onSubmit }) => {
  const [minutes, setMinutes] = useState(60);
  const [error, setError] = useState("");

  // Rate per minute in INR (from backend helper.js)
  const RATE_PER_MIN = 6.65;

  // Calculate total amount
  const totalAmount = (minutes * RATE_PER_MIN).toFixed(2);

  const handleMinutesChange = (e) => {
    const value = parseInt(e.target.value) || 0;
    setMinutes(value);
    setError("");
  };

  const validateAndSubmit = () => {
    if (minutes % 30 !== 0) {
      setError("Must be in multiples of 30");
      return;
    }
    if (minutes <= 0) {
      setError("Please enter a valid number of minutes");
      return;
    }
    onSubmit(minutes);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="buy-minutes-modal">
        {/* Modal Header */}
        <div className="modal-header">
          <div className="modal-title">
            <h2>Buy More Minutes</h2>
          </div>
          <button className="modal-close-btn" onClick={onClose}>
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>

        {/* Modal Description */}
        <div className="modal-description">
          <p>Increase your balance to schedule more coaching sessions.</p>
        </div>

        {/* Input Section */}
        <div className="input-section">
          <label>Minutes to Buy</label>
          <div className="input-container">
            <input
              type="number"
              value={minutes}
              onChange={handleMinutesChange}
              min="0"
              step="30"
              placeholder="60"
            />
            <span className="mins-label">MINS</span>
          </div>
          {error && <p className="error-text">{error}</p>}
          <p className="hint-text">Must be in multiples of 30</p>
        </div>

        {/* Cost Display */}
        <div className="cost-display">
          <div className="cost-item">
            <span className="cost-label">Total Amount</span>
            <span className="cost-value">₹{totalAmount}</span>
          </div>
          <div className="cost-item">
            <span className="cost-label">Selected Package</span>
            <span className="package-value">{minutes} minutes</span>
          </div>
        </div>

        {/* Modal Footer */}
        <div className="modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="pay-btn" onClick={validateAndSubmit}>
            Pay Now
            <span className="material-symbols-outlined">arrow_forward</span>
          </button>
        </div>

        {/* Security Badge */}
        <div className="security-badge">
          <span className="material-symbols-outlined">lock</span>
          <span>Secure 256-bit Encrypted Checkout</span>
        </div>
      </div>
    </div>
  );
};

export default BuyMinutesModal;
